import { defaultHttpClient } from '../../httpClient';
import type { PostNonEntryMarketsParams } from './types';

export const postNonEntryMarkets = async (
  params: PostNonEntryMarketsParams,
) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: '/api/v2/non-entry-markets/',
      data: params,
    })
    .then(result => result.data);
};
